// import isUndefined from 'lodash/isUndefined';

// import { renderCurrency } from '../../components/SystemCountry';

// import getFilterWithCol from '../../helpers/getFilterWithCol';

import tests from '../../helpers/tests';

import { createDefaultFields } from './helpers';

// import { createChangeLogSection } from '../../components/FieldChangeLog';

// import Types from '../../modules/types';

const { viewerIsNotThehiveRsAdmin } = tests;

export default [
  'PageSingle',
  {
    // icon: 'tool',
    path: '/settings/content-builder-library-generate',
    title: 'CB Library Generate',
    headerTitle: 'CB Library Generate',
    renderHeaderTitle: () => 'CB Library Generate',
    hidden: false,
    activity: 'edit',
    url: '/settings/contentBuilderLibraryGenerate',
    redirect: [['redirect.unauthorized']],
    actions: [['ActionSave']],
    skip: [viewerIsNotThehiveRsAdmin],
    fields: createDefaultFields(),
  },
];
